export const timeConfig = {
    timezone: 'America/New_York',
    timeFormat: 'MMM D [@] LT z',
    nonTimeZoneTimeFormat: 'MMM D [@] LT',
    dayAndMonth: 'MMM D',
    pdfTimeFormat: 'MMM D Y',   
    dateTimeFormat: 'Y-MM-DD HH:mm:ss z',
    standardFormat: 'MM/DD/Y HH:mm:ss z',
    dateTimeFormatWithoutTimezone: 'Y-MM-DD HH:mm:ss',
    dateFormat: 'YYYY-MM-DD',   
};


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/constants/time.config.ts